import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Small inline SVG marks used in the pricing table: a check for
 * "included" and a dash for "not included". Lightweight — no external
 * icon library. Colours follow currentColor so the caller tints via
 * inline style.
 */
import { mono } from '../fonts.js';
export function CheckMark() {
    return (_jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", "aria-hidden": "true", style: { display: 'block' }, children: _jsx("path", { d: "M3.5 8.5l3 3 6-7", fill: "none", stroke: "currentColor", strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}
export function DashMark() {
    return (_jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", "aria-hidden": "true", style: { display: 'block' }, children: _jsx("path", { d: "M5 8h6", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }) }));
}
/** Small "Early access" tag shown after a label. */
export function EarlyTag({ theme }) {
    return (_jsx("span", { style: {
            ...mono,
            fontSize: 10,
            letterSpacing: 0.8,
            textTransform: 'uppercase',
            color: theme.skyFg,
            border: '1px solid currentColor',
            borderRadius: 2,
            padding: '0 4px',
            marginLeft: 6,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            verticalAlign: 'baseline',
        }, children: "Early access" }));
}
//# sourceMappingURL=icons.js.map